module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"row\">\r\n    <div class=\"prop-header\"><span class=\"prop-label\">Show Report Settings</span></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-8\"><input type=\"text\" value=\"")
    ; __append(escapeFn(formOrReport))
    ; __append("\" readonly=\"readonly\"></input></div>\r\n    <div class=\"col-md-4\"><input id=\"selectReport\" class=\"btn btn-default hvr-glow\" type=\"button\" name =\"formButton\" value=\"Select Report\"></input></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"checkbox\" name=\"newWindow\" ")
    ; __append(escapeFn(newWindow))
    ; __append(" class=\"form-radio-group\"></input> \r\n        <label class=\"form-group-label\">Open in new window</label> \r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 form-group-flex\">\r\n        <input type=\"checkbox\" name=\"showErrors\" ")
    ; __append(escapeFn(showErrors))
    ; __append(" class=\"form-radio-group\"> ></input>\r\n        <label class=\"form-group-label\"> Show error messages</label>\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"prop-header\"><span class=\"prop-label\">Custom Parameters</span></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <table id=\"propMainTable\"></table>\r\n        <div id=\"propMainGridButtons\" class=\"\">\r\n            <button type=\"button\" title=\"new\" name=\"itemNew\" class=\"itemNew btn btn-default hvr-glow tbl-icon\" style=\"\">\r\n                <i class=\"fa pf-add\" style=\"\"></i>\r\n            </button>\r\n            <button type=\"button\" title=\"remove\"  name=\"itemRemove\" class=\"itemRemove btn btn-default hvr-glow tbl-icon\" style=\"\">\r\n                <i class=\"fa pf-delete icon-gradient\"></i>\r\n            </button>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}